import { render, staticRenderFns } from "./SearchIDardList.vue?vue&type=template&id=1b4ca89e&"
import script from "./SearchIDardList.vue?vue&type=script&lang=js&"
export * from "./SearchIDardList.vue?vue&type=script&lang=js&"
import style0 from "./SearchIDardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports